// extracted by mini-css-extract-plugin
export var dropdownIcon = "_p7-6";
export var imgContainer = "_p7-3";
export var menuIcon = "_p7-5";
export var pillWrapper = "_p7-2";
export var pillsContainer = "_p7-1";
export var subscriptionCard = "_p7-0";
export var subscriptionLogo = "_p7-4";